import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTrainingDashboard } from '../../../features/staffTraining/staffTrainingActions';
import { filterTrainingStaff, selectCanEditTraining } from '../../../features/staffTraining/staffTrainingSelectors';
import { getLocalTodayString } from '../../../components/CreationDate';
const Context = createContext(null);
export function StaffTrainingProvider({ children }) {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(getLocalTodayString);
  const [search, setSearch] = useState(''), [status, setStatus] = useState(''), [category, setCategory] = useState('');
  const [page, setPage] = useState(1), [panel, setPanel] = useState(null), [refreshKey, setRefreshKey] = useState(0);
  const state = useSelector(store => store.staffTraining.dashboard);
  const canEdit = useSelector(selectCanEditTraining);
  useEffect(() => { const request = dispatch(fetchTrainingDashboard(selectedDate)); return () => request.abort(); }, [dispatch, selectedDate, refreshKey]);
  useEffect(() => { setPage(1); }, [search, status, category, selectedDate]);
  const data = state.data?.asOf === selectedDate ? state.data : null;
  const rows = useMemo(() => filterTrainingStaff(data?.staff || [], { search, status, category }), [data, search, status, category]);
  const pageCount = Math.max(1, Math.ceil(rows.length / 8));
  const currentPage = Math.min(page, pageCount);
  return <Context.Provider value={{ data, loading: state.loading, error: state.error, selectedDate, setSelectedDate,
    search, setSearch, status, setStatus, category, setCategory, rows, page: currentPage, setPage, pageCount,
    visibleRows: rows.slice((currentPage - 1) * 8, currentPage * 8), panel, setPanel, canEdit,
    refresh: () => setRefreshKey(value => value + 1), emptyMessage: state.loading ? 'Loading training records…' : state.error ? 'Unable to load training records.' : 'No training records found.' }}>
    {children}
  </Context.Provider>;
}
export const useStaffTraining = () => useContext(Context);
